import * as Models from "../ts/rlAdmin.models";
import * as Consts from "../ts/rlAdmin.consts";
import * as Utils from "../ts/rlAdmin.utils";

import { BaseAssociationController } from "../controllers/base-associations-controller";
import { NotifyService } from "../services/notify-service";
import { ContactService } from "../services/contact-service";
import { EntityService } from "../services/entity-service";
import { EventService } from "../services/event-service";
import { SearchService } from "../services/search-service";
import { ModalService } from "../services/modal-service";
import { AclService } from "../services/acl-service";


export function RLAssociateContacts() {

    const directive: ng.IDirective = {
        restrict: "EA",
        template: require("/assets/app/templates/associate-contacts.html"),
        controllerAs: "acVM",
        controller: ContactAssociationsController,
        bindToController: true,
        scope: {
            modalTitle: "=",
            entityID: "=entityId",
            templateID: "=templateId",
            newContact: "=",
            showModal: "="
        }
    };

    return directive;
}



export class ContactAssociationsController extends BaseAssociationController<Models.IEntitySearchDoc> {
    static $inject = ["$scope", "$window", "$filter", "$q",
        "notifyService", "contactService", "entityService", "eventService", "searchService", "modalService", "aclService"];

    modalTitle: string;
    entityID: string;
    templateID: number;
    newContact: Models.IContactSearchModel;
    showModal: boolean;
    direction: number;
    charTypeID: number;
    filterByTemplateIds: number[];
    contactTemplates: Models.ICharacteristicTemplate[];

    constructor(
        private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private $filter: ng.IFilterService,
        private $q: ng.IQService,
        private notifyService: NotifyService,
        private contactService: ContactService,
        private entityService: EntityService,
        private eventService: EventService,
        private searchService: SearchService,
        private modalService: ModalService,
        private aclService: AclService) {

        super($scope, $window, $filter, $q, notifyService, entityService, eventService);
        this.direction = 0;
        this.charTypeID = Consts.CharTypeIDs.user;
        this.filterByTemplateIds = [];

        $scope.$on('createContactDialogActive', (event, isCreateComplete: boolean) => {
            if (isCreateComplete) {
                this.RefreshAll();
            }
        });

        $scope.$watchCollection(() => [this.entityID, this.templateID],
            (newValue, oldValue) => {
                if (this.entityID && this.templateID && this.newContact) {
                    this.Init(this.entityID, this.templateID, '');
                }
            });

        $scope.$watch(() => this.showModal, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.UpdateContacts();
            }
        });

        $scope.$watch(() => this.direction, (newValue, oldValue) => {
            if (newValue !== oldValue) {
                this.UpdateContacts();
            }
        });

        $scope.$watch(() => this.search.itemRows, (newValue, oldValue) => {
            //This route is used because the existing removal of added entities in the search
            //conflicts with create w/options in the modals
            if (newValue !== oldValue && this.newContact) {
                _.remove(newValue,
                    (item) => item.recordID === this.newContact.contactID);
            }
		});		
    }

    NewContact(template: Models.ICharacteristicTemplate) {
        this.showModal = false;
        const divID = Utils.IdBuilder.splitEntityID(this.entityID).divID;
        const templateID = Utils.IdBuilder.buildTemplateID(divID, Consts.CharTypeIDs.user, template.templateID);
        this.modalService.createEntityByTemplate(templateID, undefined, undefined, undefined, true, undefined)
            .then((result) => {
                this.selectedSearchIDs = [Utils.IdBuilder.splitEntityID(result.entityID).recID];
                this.SetAssociated(this.direction);
            });
    }

    SubGetAssociationHeirarchy() {
        let recID = this.recordID;

        if (this.newContact) {
            recID = this.newContact.contactID;
        }

        return this.contactService.getHierarchy(recID);
    }

    SubRemoveAssociated() {
        let recID = this.recordID;

        if (this.newContact) {
            recID = this.newContact.contactID;
        }

        return this.contactService.deleteAssociations(recID, this.selectedAssociatedIDs);
    }

    SubSetAssociated() {
        let recID = this.recordID;
        if (this.newContact) {
            recID = this.newContact.contactID;
        }

        this.showModal = false;
        return this.contactService.createAssociations(recID, this.selectedSearchIDs, this.direction);
    }

    SubSearch(searchState: Models.IAdvancedSearchModel) {
        //Clear out this option since we do want children of the parent entity
        searchState.notChildrenOfEntityID = "";
        searchState.filterByTemplateIds = this.filterByTemplateIds;

        return this.searchService.advancedSearch(searchState);
    }

    SetAssociated(direction: number) {
        this.direction = direction;

        this.notifyService.startProgress();
        this.SubSetAssociated()
            .then(() => {
                this.selected.search = {};
                this.modalOpen = false;
                return this.GetAssociationHierarchy();
            })
            .then(() => {
                this.notifyService.notifySuccess("Record successfully associated.");
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Delete() {
        if (this.$window.confirm("Are you sure you want to delete this Contact?") && this.$window.confirm("Are you REALLY SURE you want to delete this Contact?")) {
            this.notifyService.startProgress();
            this.entityService.deleteEntity(this.entityRecord.id)
                .then(() => {
                    this.$window.location.assign(Consts.Urls.ContactListPage);
                },
                () => {
                    this.notifyService.notifyError("Error Deleting Contact");
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        } else {
            this.$scope.$broadcast(Consts.Events.NotifyDone);
        }
    }

    UpdateContacts() {
        let templateID = 0;

        if (this.newContact && this.newContact.charDataCollection) {
            templateID = this.newContact.charDataCollection.templateMetaData.templateID;
        }

        if (this.direction === 1) {
            this.entityService.getAssociatedParentTemplatesForTemplate(Consts.CharTypeIDs.user, templateID, Consts.CharTypeIDs.user)
                .then((result) => {
                    this.contactTemplates = result.filter(ct => Utils.AclUtil.hasReadAccess(this.aclService.acls, ct.acl));
                    this.filterByTemplateIds = this.contactTemplates.map(r => r.templateID);
                })
                .finally(() => {
                    this.Search();
                });
        }
        else {
            this.entityService.getAssociatedTemplatesForTemplate(Consts.CharTypeIDs.user, templateID, Consts.CharTypeIDs.user)
                .then((result) => {
                    this.contactTemplates = result.filter(ct => Utils.AclUtil.hasReadAccess(this.aclService.acls, ct.acl));
                    this.filterByTemplateIds = this.contactTemplates.map(r => r.templateID);
                })
                .finally(() => {
                    this.Search();
                });
        }
    }

    RefreshAll(): ng.IPromise<any> {
        return this.RefreshValidation();
    }

    RefreshValidation(): ng.IPromise<any> {
        return this.eventService.call(Consts.Events.ValidateEntity);
    }

    CopySuccessful(newEntityID: string) {
        this.$window.location.assign("/Go/" + newEntityID);
    }
}
